import { type PaginationState, type ColumnFiltersState, type SortingState } from '@tanstack/react-table'
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

export interface TableState {
  pagination: PaginationState
  setPagination: Dispatch<SetStateAction<PaginationState>>
  columnFilters: ColumnFiltersState
  setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>
  sorting: SortingState
  setSorting: Dispatch<SetStateAction<SortingState>>
}

export const useTableState = (defaultSorting?: SortingState): TableState => {
  const [pagination, setPagination] = useState<PaginationState>({ pageIndex: 0, pageSize: 25 })
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  const [sorting, setSorting] = useState<SortingState>(defaultSorting ?? [])

  useEffect(() => {
    if (sorting.length === 0 && defaultSorting) {
      setSorting(defaultSorting)
    }
  }, [sorting])

  return { pagination, setPagination, columnFilters, setColumnFilters, sorting, setSorting }
}
